module.exports = __webpack_public_path__ + "static/media/articlesList-bg-shape.88d05db6.svg";